<template>
  <div class="pages">
    <!-- <audio ref="audioclass" class="audioclass" id="audioclass" style="position: absolute; top: 0;">
      <source src="@/assets/fanshu.wav" type="audio/ogg" />
    </audio> -->
    <div class="phone" style="width:100%;height:100%">
      <audio ref="audio">
        <source src="@/assets/audio/fanshu.wav" type="audio/ogg" />
      </audio>
      <div class="one-main" id="flipbook" @touchstart="handleTouchstart" @touchend="handleTouchend">
        <div class="book_item" >
          <img src="@/assets/image/one_img/bg_t.png" class="img_top"/>
          <img src="@/assets/image/one_img/bg_b.png" class="img_bottom"/>
          <Summary_one v-if="sumlist[0]"/>
        </div>
        <div class="book_item" >
          <img src="@/assets/image/one_img/bg_t.png" class="img_top"/>
          <img src="@/assets/image/one_img/bg_b.png" class="img_bottom"/>
          <Summary_two v-if="sumlist[1]"/>
        </div>
        <div class="book_item">
          <img src="@/assets/image/one_img/bg_t.png" class="img_top"/>
          <img src="@/assets/image/one_img/bg_b.png" class="img_bottom"/>
          <Summary_three v-if="sumlist[2]"/>
        </div>
        <div class="book_item">
          <img src="@/assets/image/one_img/bg_t.png" class="img_top"/>
          <img src="@/assets/image/one_img/bg_b.png" class="img_bottom"/>
          <Summary_four v-if="sumlist[3]"/>
        </div>
        <div class="book_item">
          <img src="@/assets/image/one_img/bg_t.png" class="img_top"/>
          <img src="@/assets/image/one_img/bg_b.png" class="img_bottom"/>
          <Summary_five v-if="sumlist[4]"/>
        </div>
      </div>
      <div class="xf_text">
        <div class="xf_t wow animate__bounce" v-if="iconlist">
          <div class="xf_t1" @click="textClick(1)">
            <img src="@/assets/summany/gaishu/icon1.png" class="xf_t_img">
            公司简介
          </div>
          <div class="xf_t1" @click="textClick(2)">
            <img src="@/assets/summany/gaishu/icon2.png" class="xf_t_img">
            文化理念
          </div>
          <div class="xf_t1" @click="textClick(3)">
            <img src="@/assets/summany/gaishu/icon3.png" class="xf_t_img">
            核心优势
          </div>
          <div class="xf_t1" @click="textClick(4)">
            <img src="@/assets/summany/gaishu/icon5.png" class="xf_t_img">
            发展历程
          </div>
          <div class="xf_t1" @click="textClick(5)">
            <img src="@/assets/summany/gaishu/icon4.png" class="xf_t_img">
            公司荣誉
          </div>
          <div class="xf_t1" @click="textClick(6)">
            <img src="@/assets/summany/gaishu/icon6.png" class="xf_t_img">
            返回首页
          </div>
        </div>
        <div class="xf_b fx f_a_c" @click="iconClick">
          <img src="@/assets/summany/gaishu/caidan.png"  class="xf_t_img">
        </div>
      </div>
    </div>
    <div class="computer">
      <Head />
      <div class="top_img">
          <img src="@/assets/computer/shouye/gsjj1.jpg" v-if="indexT==0" style="width: 100%;height:auto;display: block;">
          <img src="@/assets/computer/shouye/gsjj2.jpg" v-if="indexT==1" style="width: 100%;height:auto;display: block;">
          <img src="@/assets/computer/shouye/gsjj3.jpg" v-if="indexT==2" style="width: 100%;height:auto;display: block;">
          <img src="@/assets/computer/shouye/gsjj4.jpg" v-if="indexT==3" style="width: 100%;height:auto;display: block;">
          <img src="@/assets/computer/shouye/gsjj5.jpg" v-if="indexT==4" style="width: 100%;height:auto;display: block;">
      </div>
      <div class="Navigation fx cursor">
          <div :class="indexT==index ?'back navigation_item fx f_a_c f_j_ce' :'navigation_item fx f_a_c f_j_ce' " @click="itemClick(index)" v-for="(item,index) in toplist">
              <img :src="item.img1"  v-if="indexT==index">
              <img :src="item.img" v-else>
              <div class="fs_01 pl005">{{item.text}}</div>
          </div>
      </div>
      <!-- 页标 -->
      <div class="yebiao fs_0075 color2 cursor"><span @click="syClick">首页</span> - <span @click="gyClick">关于我们</span></div>
      <div v-if=" indexT==0 ">
        <SummaryA />
      </div>
      <div v-if=" indexT==1 ">
        <SummaryB/>
      </div>
      <div v-if=" indexT==2 ">
        <SummaryC/>
      </div>
      <div v-if=" indexT==3 ">
        <SummaryD/>
      </div>
      <div v-if=" indexT==4 ">
        <SummaryE/>
      </div>
      <Footer/>
    </div>
    
  </div>
  
</template>

<script setup>
import Summary_one from '@/components/mobilephone/summary_one.vue'
import Summary_two from '@/components/mobilephone/summary_two.vue'
import Summary_three from '@/components/mobilephone/summary_three.vue'
import Summary_four from '@/components/mobilephone/summary_four.vue'
import Summary_five from '@/components/mobilephone/summary_five.vue'

import Head from '@/components/computer/head.vue'
import Footer from '@/components/computer/Footer.vue'
import SummaryA from '@/components/computer/summaryA.vue'
import SummaryB from '@/components/computer/summaryB.vue'
import SummaryC from '@/components/computer/summaryC.vue'
import SummaryD from '@/components/computer/summaryD.vue'
import SummaryE from '@/components/computer/summaryE.vue'

import { ref, nextTick, onMounted,inject  } from 'vue'
import turn from '@/untils/turn.js'
import $ from 'jquery'
import { useRouter } from 'vue-router'
const router = useRouter()
import { useStore } from "vuex";


const syClick = ()=>{
    router.push('/home')
}
const gyClick = ()=>{
  router.push('/summary')
}
let indexT = ref('')
indexT.value = router.currentRoute._value.query.index1
const toplist =ref([
    {
        text:'公司介绍',
        img:require('@/assets/computer/summary/gsjj1.png'),
        img1:require('@/assets/computer/summary/gsjj2.png'),
    },{
        text:'文化理念',
        img:require('@/assets/computer/summary/wh1.png'),
        img1:require('@/assets/computer/summary/wh2.png'),
    },{
        text:'核心优势',
        img:require('@/assets/computer/summary/hx1.png'),
        img1:require('@/assets/computer/summary/hx2.png'),
    },{
        text:'发展历程',
        img:require('@/assets/computer/summary/fzlc1.png'),
        img1:require('@/assets/computer/summary/fzlc2.png'),
    },{
        text:'公司荣誉',
        img:require('@/assets/computer/summary/qyry1.png'),
        img1:require('@/assets/computer/summary/qyry2.png'),
    }
])

const itemClick = (i)=>{
    indexT.value = i
}


onMounted(() => {
    inject('reload') 
    if (sWidth<=900) {
      onTurn()
    }
})

const store = useStore(); 
let sWidth = store.state.screenWidth
let sHeight = store.state.screenHeight

//屏幕滑动
//手指按下屏幕
let pagelist = 5
let currents = 1
let startTime = ref(0)
let startX = ref(0)
let startY = ref(0)
const handleTouchstart = (event)=>{
 startTime = Date.now()
 startX = event.changedTouches[0].clientX
 startY = event.changedTouches[0].clientY
}
//手指离开屏幕
const handleTouchend = (event) =>{
  const endTime = Date.now()
  const endX = event.changedTouches[0].clientX
  const endY = event.changedTouches[0].clientY
  //判断按下的时长
  if(endTime - startTime >2000){
    return
  }
  //滑动的方向
  let direction = "";
  //先判断用户滑动的距离，是否合法，合法:判断滑动的方向 注意 距离要加上绝对值
  if(Math.abs(endX -startX)>10){
    //滑动方向
    if(Math.abs(endY -startY)>30){
      // console.log("y方向偏移太多，不让你滑了")
      return
    }else{
      direction = endX -startX >0?"right":"left"
    }
  }else{
    return
  }
  //用户做了合法的滑动操作
  // console.log('方向'+direction)
  if(direction==='left'){
    if(currents===pagelist){
      return
    }else{
      currents++
      //触发事件
      booknext()
     
    }
  }
  if(direction==='right'){
    if(currents===1){
      return
    }else{
      currents--
      //触发事件
      bookprevious()
    }
  }
}
// 翻书
const onTurn = () => {
  console.log('cde');
  nextTick(() => {
    $('#flipbook').turn({
      height: '100%' , //高度
      width: sWidth, //宽度
      display: 'single', //单页显示/双页显示  single/double
      elevation: 50,
      duration: 500, //翻页速度(毫秒), 默认600ms
      gradients: true, //翻页时的阴影渐变, 默认true
      autoCenter: true, //自动居中, 默认false
      acceleration: true, //硬件加速, 默认true, 如果是触摸设备设置为true
      page: 1, //设置当前显示第几页
      pages: 5, //总页数
      peel:'r,l,tr,br,tl,bl',
      when: {
        //监听事件
        turning: function (e, page, view) {
          // console.log(e, page, view)
          // 翻页前触发.
        },
        turned: function (e, page) {
          // console.log(e, page)
          currentPage.value = page
          // 翻页后触发
          plays()
          bookClick()
        },
      },
    })
  })
}
const sumlist = ref([true,false,false,false,false])
const bookClick = ()=>{
  console.log(sumlist.value);

  if (currentPage.value==1) {
    sumlist.value = [true,false,false,false,false]
  }else if(currentPage.value==2){
    sumlist.value = [false,true,false,false,false]
  }else if (currentPage.value==3) {
    sumlist.value = [false,false,true,false,false]
  }else if(currentPage.value==4){
    sumlist.value = [false,false,false,true,false]
  }else{
    sumlist.value = [false,false,false,false,true]
  }
  console.log(sumlist.value);
}
const currentPage = ref(1)
// 音频控制
const audio = ref();
const plays = () => {
  if (audio.value) {
    audio.value.play();
  }
};
let iconlist = ref(true)
const iconClick = ()=>{
  iconlist.value = !iconlist.value
}
const textClick=(e)=>{
  if (e==6) {
    router.push('/home')
  }else{
    $("#flipbook").turn("page",e)
  }
}
const booknext = () =>{
  nextTick(() => {
    $('#flipbook').turn('next')
  })
}
const bookprevious = () =>{
  nextTick(() => {
    $('#flipbook').turn('previous')
  })
}

</script>

<style scoped>
@media (min-width:900px) {
.phone{
  display: none;
}
.computer{
  width: 100%;
}
.yebiao{
    width: 85%;
    margin: 0.2rem auto 0.3rem;
}
.Navigation {
    width: 85%;
    margin: -0.16rem auto 0;
    border-left: 1px solid #d3d3d3;
    border-top: 1px solid #d3d3d3;
    border-bottom: 1px solid #d3d3d3;
}
.navigation_item{
    width: 20%;
    text-align: center;
    padding: 0.15rem 0;
    border-right: 1px solid #d3d3d3;
    background-color: #fff;
}
.navigation_item img{
    width: 0.075rem;
    height: 0.075rem;
}
.back{
    background-color: red;
    color: #fff;
}
}
@media only screen and (max-width: 900px) {
.computer{
  display: none;
}
.phone{
  width: 100%;
  height: 100%;
}
.pages{
  width: 100%;
  height: 100%;
  background-color:#d4e9ff ;
  position: relative;
}
.one-main{
  width: 100%;
  height: 100%;
  position: absolute ;
  top: 0;
  left: 0;
  z-index: 5;
  background-color:#d4e9ff ;
}
.book_item{
  width: 100%;
  height: 100%;
}
.img_top{
    width: 100%;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 4;
}
.img_bottom{
    width: 100%;
    height: auto;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 4;
}

/* 悬浮按钮 */
.xf_text{
  position: absolute;
  bottom: 5%;
  right: 2%;
  z-index: 6;
  font-size: 0.3rem;
  text-align: center;
  color: #fff;
  opacity: 0.8;
}
.xf_t{
  width: 1.4rem;
  padding: 0.4rem 0.15rem 0.8rem;
  background-color: #e71919;
  border-radius: 1rem;
}
.xf_t1{
  padding: 0.23rem 0;
  border-bottom: 1px dashed #fff;
}
.xf_t_img{
  width: 0.6rem;
    height: 0.6rem;
    display: block;
    margin: 0 0.45rem 0.1rem;
}


.xf_b{
  width: 1.5rem;
  height: 1.5rem;
  padding: 0.1rem;
  background-color: #e71919;
  margin-top: 0.3rem;
  border-radius: 100%;
}

}

</style>
